import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useQueryTimelineAndDensity } from 'api/queries/timelineAndDensity.query';

import { FilterNames, getFiltersData } from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';

export const useTimelineAndDensityProvider = ({ widgetId, localFilters, globalFilterData }) => {
    const isInPinboard = Boolean(widgetId);
    const source = isInPinboard ? localFilters : { ...globalFilterData };

    return {
        ui: {
            state: getState(source),
            pills: useGetPills(source, widgetId),
        },
        api: {
            getTimelineAndDensity: {
                instance: useQueryTimelineAndDensity(getTimelineAndDensityPayload(source)),
                payload: getTimelineAndDensityPayload(source),
            },
        },
    };
};

const useGetPills = (source, widgetId) => {
    const pillsData = {
        programTags: source?.programTags?.map((item) => item.label),
    };

    const { pillsList: pills } = useGlobalFiltersHook({
        widgetId,
        latestVersionId: undefined,
        source: pillsData,
    });

    return pills;
};

const getTimelineAndDensityPayload = (source) => {
    return {
        filter: {
            filters: getFiltersData({
                [FilterNames.TAG_PORTFOLIO_BOARD]: source?.programTags?.map((item) => item.value),
            }),
        },
    };
};

const getState = (source) => {
    return {
        //global
        programTags: source?.programTags,
    };
};
